export default __webpack_public_path__ + "static/media/pinterestHoverSvg.d13b5251.svg";